import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { DefaultMatterFileRepositoryStructure } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterFileRepositoryStructureContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  onDelete: () => void;
  onEdit: () => void;
  structure: DefaultMatterFileRepositoryStructure;
  trigger: ReactNode;
};

export function MatterFileRepositoryStructureContextMenu({
  canDelete,
  canEdit,
  onDelete,
  onEdit,
  structure,
  trigger,
}: MatterFileRepositoryStructureContextMenuProps) {
  return (
    <ContextMenu
      entityName="folder structure"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(structure.label, "Folder structure name");
            }}
          >
            <Clipboard />
            Copy structure name
          </ContextMenuItem>
          <ContextMenuItem
            disabled={!structure.description}
            onSelect={() => {
              void copyToClipboard(structure.description ?? "", "Description");
            }}
          >
            <Clipboard />
            Copy description
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
